export default __webpack_public_path__ + "static/media/excel.76cf6036.png";